import Card from '_app/components/Card'
import {useCheckoutContext} from '../hooks'
import {DeliveryDetailsCard} from './DeliveryDetailsCard'
import {DeliveryOptionCard} from './DeliveryOptionCard'

export const DeliveryCard = ({ data }) => {
  const { selectedShippingMethod } = useCheckoutContext()
  return (
    <Card mb={6}>
      <DeliveryOptionCard data={data} />
      {selectedShippingMethod && <DeliveryDetailsCard />}
    </Card>
  )
}
